<div class="button-data">
  <mat-button-toggle-group
    class="timeframe-mode-toggle"
    *ngIf="showTimeFrameModeToggle"
    [ngModel]="timeFrameMode"
    (ngModelChange)="onTimeFrameChange($event)"
    [ngModelOptions]="{ standalone: true }"
    class="button-style"
  >
    <mat-button-toggle value="year">Annual</mat-button-toggle>
    <mat-button-toggle value="quarter">Quarterly</mat-button-toggle>
  </mat-button-toggle-group>
</div>
<div class="legend-container">
  <div class="legend-item bar1"></div>
  <span>AR Date</span>
  <div class="legend-item bar2"></div>
  <span>AR Approved</span>
  <div class="legend-item bar3"></div>
  <span>Operational Date</span>
</div>
<div [ngClass]="canvasEnahanced ? 'chart-container' : ''">
  <div class="chart-wrapper">
    <div id="divChart" #chartBox>
      <canvas id="ganttChart"></canvas>
    </div>
  </div>
</div>
